define("shared/components/shared/carousel/indicators", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ol class="carousel-indicators" ...attributes>
    {{#each @carouselMediaItems as |media idx|}}
      <li class={{if (is-equal idx @index) "active"}} role="button" {{on "click" (fn @updateIndex idx)}}></li>
    {{/each}}
  </ol>
  */
  {
    "id": "n7Ts2Dqg",
    "block": "[[[11,\"ol\"],[24,0,\"carousel-indicators\"],[17,1],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,2]],null]],null],null,[[[1,\"    \"],[11,\"li\"],[16,0,[52,[28,[37,3],[[30,4],[30,5]],null],\"active\"]],[24,\"role\",\"button\"],[4,[38,4],[\"click\",[28,[37,5],[[30,6],[30,4]],null]],null],[12],[13],[1,\"\\n\"]],[3,4]],null],[13]],[\"&attrs\",\"@carouselMediaItems\",\"media\",\"idx\",\"@index\",\"@updateIndex\"],false,[\"each\",\"-track-array\",\"if\",\"is-equal\",\"on\",\"fn\"]]",
    "moduleName": "shared/components/shared/carousel/indicators.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});